export const instanceMessages = {
  "panelExtensions.section": "Extensions",
  "panelExtensions.assetsConsent": "Permission: read tool-result images and attachments from the current session, plus its identifier, language and appearance. No filesystem or network access.",
  "panelExtensions.empty": "No extensions installed.",
  "panelExtensions.catalog.title": "Available online",
  "panelExtensions.catalog.search": "Search extensions",
  "panelExtensions.catalog.loading": "Loading the official catalogue…",
  "panelExtensions.catalog.error": "Online catalogue unavailable. Installed extensions and ZIP installation remain available.",
  "panelExtensions.catalog.empty": "No matching extensions.",
  "panelExtensions.catalog.install": "Install…",
  "panelExtensions.catalog.replace": "Change version…",
  "panelExtensions.catalog.installed": "Installed",
  "panelExtensions.catalog.incompatible": "Incompatible (API {apiVersion})",
  "panelExtensions.catalog.installedTitle": "Installed extensions",
  "panelExtensions.title": "Panel extensions",
  "panelExtensions.install": "Install from ZIP…",
  "panelExtensions.error": "Extension unavailable. Check its package/API version and try again.",
  "panelExtensions.permission": "Permission: current session identifier, language and appearance only.",
  "panelExtensions.warning": "Only install authors you trust. New or replacement code starts disabled. Replacing an extension revokes its activation in every project.",
  "panelExtensions.trust": "I trust this package and its author",
  "panelExtensions.confirm": "Install disabled",
  "panelExtensions.cancel": "Cancel",
  "panelExtensions.remove": "Remove…",
  "panelExtensions.removeWarning": "Remove this extension and its activation settings from this CodeNomad profile?",
  "panelExtensions.removeConfirm": "Confirm removal",
  "instanceTabs.new.title": "New instance",
  "instanceTabs.new.launcherTitle": "New instance — long press or right-click for more",
  "instanceTabs.new.ariaLabel": "New instance",
  "instanceTabs.remote.title": "Remote connect",
  "instanceTabs.remote.ariaLabel": "Remote connect",

  "instanceInfo.title": "Instance Information",
  "instanceInfo.labels.folder": "Folder",
  "instanceInfo.labels.project": "Project",
  "instanceInfo.labels.versionControl": "Version Control",
  "instanceInfo.labels.opencodeVersion": "OpenCode Version",
  "instanceInfo.labels.binaryPath": "Binary Path",
  "instanceInfo.labels.environmentVariables": "Environment Variables ({count})",
  "instanceInfo.loading": "Loading...",
  "instanceInfo.server.title": "OpenCode process",
  "instanceInfo.server.port": "Port:",
  "instanceInfo.server.pid": "PID:",
  "instanceInfo.server.status": "Status:",

  "instanceTab.status.permission": "Waiting on permission",
  "instanceTab.status.compacting": "Compacting",
  "instanceTab.status.working": "Working",
  "instanceTab.status.idle": "Idle",
  "instanceTab.status.ariaLabel": "Instance status: {status}",
  "instanceTab.actions.close.ariaLabel": "Close instance",
  "instanceTab.actions.rename": "Rename…",
  "instanceTab.actions.keepTemporary": "Keep as project",
  "instanceTab.temporary.title": "Temporary instance: closing offers to keep or discard it",
  "instanceTab.temporary.ariaLabel": "Temporary instance",
  "temporaryInstance.name": "Temporary · {time}",
  "temporaryInstance.close.title": "Close temporary instance",
  "temporaryInstance.close.message": "Keep it as a project in your recent projects, or discard its conversations and files?",
  "temporaryInstance.close.keep": "Keep",
  "temporaryInstance.close.discard": "Discard",
  "temporaryInstance.close.cancel": "Cancel",
  "temporaryInstance.keep.failedTitle": "Unable to keep the temporary instance",
  "temporaryInstance.discard.failedTitle": "Unable to discard the temporary instance",
  "temporaryInstance.error.running": "A conversation is still running in this temporary instance. Stop it first.",
  "temporaryInstance.error.openElsewhere": "This temporary instance is open in another tab or window. Close it there first.",
  "temporaryInstance.error.notTemporary": "This instance is no longer temporary.",

  "instanceShell.leftPanel.sessionsTitle": "Sessions",
  "instanceShell.leftPanel.instanceInfo": "Instance Info",
  "instanceShell.leftDrawer.pin": "Pin left drawer",
  "instanceShell.leftDrawer.unpin": "Unpin left drawer",
  "instanceShell.leftDrawer.toggle.pinned": "Left drawer pinned",
  "instanceShell.leftDrawer.toggle.open": "Open left drawer",
  "instanceShell.leftDrawer.toggle.close": "Close left drawer",

  "instanceShell.rightDrawer.pin": "Pin right drawer",
  "instanceShell.rightDrawer.unpin": "Unpin right drawer",
  "instanceShell.rightDrawer.toggle.pinned": "Right drawer pinned",
  "instanceShell.rightDrawer.toggle.open": "Open right drawer",
  "instanceShell.rightDrawer.toggle.close": "Close right drawer",

  "instanceShell.fullscreen.enter": "Full screen",
  "instanceShell.fullscreen.exit": "Exit full screen",

  "instanceShell.metrics.usedLabel": "Used",
  "instanceShell.metrics.availableLabel": "Avail",

  "instanceShell.commandPalette.openAriaLabel": "Open command palette",
  "instanceShell.commandPalette.button": "Command Palette",
  "instanceShell.chatSearch.openAriaLabel": "Search chat history",

  "instanceShell.connection.ariaLabel": "Connection {status}",
  "instanceShell.connection.connected": "Connected",
  "instanceShell.connection.connecting": "Connecting...",
  "instanceShell.connection.disconnected": "Disconnected",
  "instanceShell.connection.unknown": "Unknown",

  "instanceWelcome.shortcuts.newSession": "New Session",
  "instanceWelcome.empty.title": "No Previous Sessions",
  "instanceWelcome.empty.description": "Create a new session below to get started",
  "instanceWelcome.loading.title": "Launching workspace",
  "instanceWelcome.loading.description": "Starting OpenCode for this workspace...",
  "instanceWelcome.resume.title": "Resume Session",
  "instanceWelcome.resume.subtitle.one": "{count} session available",
  "instanceWelcome.resume.subtitle.other": "{count} sessions available",
  "instanceWelcome.session.untitled": "Untitled Session",
  "instanceWelcome.new.title": "Start New Session",
  "instanceWelcome.new.subtitle": "We’ll reuse your last agent/model automatically",
  "instanceWelcome.new.createButton": "Create Session",
  "instanceWelcome.overlay.close": "Close",
  "instanceWelcome.actions.viewInstanceInfo": "View Instance Info",
  "instanceWelcome.actions.renameTitle": "Rename session",
  "instanceWelcome.actions.deleteTitle": "Delete session",
  "instanceWelcome.hints.navigate": "Navigate",
  "instanceWelcome.hints.jump": "Jump",
  "instanceWelcome.hints.firstLast": "First/Last",
  "instanceWelcome.hints.resume": "Resume",
  "instanceWelcome.hints.delete": "Delete",
  "instanceWelcome.toasts.renameError": "Unable to rename session",

  "instanceDisconnected.title": "Instance Disconnected",
  "instanceDisconnected.folderFallback": "this workspace",
  "instanceDisconnected.reasonFallback": "The server stopped responding",
  "instanceDisconnected.description": "{folder} can no longer be reached. Close the tab to continue working.",
  "instanceDisconnected.details.title": "Details",
  "instanceDisconnected.details.folderLabel": "Folder:",
  "instanceDisconnected.actions.closeInstance": "Close Instance",

  "instanceShell.empty.title": "No session selected",
  "instanceShell.empty.description": "Send a message below to create a new session, or select an existing session to continue.",

  "instanceShell.rightPanel.title": "Status Panel",
  "instanceShell.rightPanel.tabs.gitChanges": "Git",
  "gitPanel.history": "History",
  "filesPanel.workspace": "Workspace",
  "filesPanel.commits": "Commits",
  "filesPanel.gitInit.notRepository": "This folder is not a Git repository.",
  "filesPanel.gitInit.action": "Initialize Git",
  "filesPanel.gitInit.pending": "Initializing…",
  "filesPanel.gitInit.success": "Git repository initialized",
  "filesPanel.gitInit.error": "Unable to initialize Git: {message}",
  "filesPanel.gitInit.unsupported": "This OpenCode version cannot initialize a Git repository here.",
  "filesPanel.gitInit.exists": "This folder already belongs to a repository.",
  "filesPanel.gitInit.mismatch": "Only the opened folder can be initialized; it belongs to another project.",
  "filesPanel.gitInit.notOwned": "This folder is no longer open in this workspace.",
  "filesPanel.gitInit.deleting": "This folder is being removed.",
  "filesPanel.gitInit.gitRequired": "Git is not available to CodeNomad.",
  "filesPanel.viewer": "File preview",
  "filesPanel.readOnly": "Read-only",
  "filesPanel.binary": "Preview unavailable for this binary file.",
  "filesPanel.image.before": "Before",
  "filesPanel.image.after": "After",
  "gitPanel.changes": "Changes",
  "gitPanel.view": "Git view",
  "gitPanel.worktree": "Worktree to browse",
  "gitPanel.detached": "Detached HEAD",
  "gitPanel.filter": "Filter loaded commits…",
  "gitPanel.emptyHistory": "No commits to display",
  "gitPanel.more": "Load older commits",
  "gitPanel.files": "{count} changed files",
  "gitPanel.actions": "Git actions",
  "gitPanel.diff": "Git diff",
  "gitPanel.parentDiff": "Compared with first parent",
  "gitPanel.backChat": "Back to conversation",
  "instanceShell.rightPanel.tabs.files": "Files",
  "instanceShell.rightPanel.tabs.status": "Status",
  "instanceShell.rightPanel.tabs.ariaLabel": "Right panel tabs",
  "instanceShell.rightPanel.modules.core": "CodeNomad core",
  "instanceShell.rightPanel.modules.core.description": "Built-in Git, Files, and Status panels.",
  "instanceShell.rightPanel.customize.toggle": "Customize right panel",
  "instanceShell.rightPanel.customize.title": "Customize right panel",
  "instanceShell.rightPanel.customize.description": "Show or hide right panel modules.",
  "instanceShell.rightPanel.customize.reset": "Reset",
  "instanceShell.rightPanel.customize.tabs": "Tabs",
  "instanceShell.rightPanel.customize.sections": "Customize sections",
  "instanceShell.rightPanel.customize.statusSections": "Status sections",
  "instanceShell.rightPanel.customize.dragToReorder": "Drag to reorder.",
  "instanceShell.rightPanel.customize.alwaysVisible": "Always visible",
  "instanceShell.rightPanel.customize.unavailableModules": "Unavailable modules",
  "instanceShell.rightPanel.customize.moduleUnavailable": "{module} unavailable",
  "instanceShell.rightPanel.customize.moveUp": "Up",
  "instanceShell.rightPanel.customize.moveDown": "Down",
  "instanceShell.rightPanel.customize.moveTabUp": "Move {label} tab up",
  "instanceShell.rightPanel.customize.moveTabDown": "Move {label} tab down",
  "instanceShell.rightPanel.customize.moveStatusSectionUp": "Move {label} status section up",
  "instanceShell.rightPanel.customize.moveStatusSectionDown": "Move {label} status section down",
  "instanceShell.rightPanel.actions.refresh": "Refresh",
  "instanceShell.rightPanel.actions.save": "Save",
  "instanceShell.rightPanel.actions.saveConfirm.message": "Do you want to save changes to \"{path}\" before switching?",
  "instanceShell.rightPanel.actions.saveConfirm.confirmLabel": "Save",
  "instanceShell.rightPanel.actions.saveConfirm.cancelLabel": "Discard Changes",
  "instanceShell.rightPanel.actions.conflict.message": "File was modified by the agent. Overwrite agent's changes?",
  "instanceShell.rightPanel.actions.conflict.confirmLabel": "Overwrite",
  "instanceShell.rightPanel.actions.conflict.cancelLabel": "Cancel",
  "instanceShell.rightPanel.actions.refreshDirty.message": "File has unsaved changes. Refresh will discard your edits. Continue?",
  "instanceShell.rightPanel.actions.refreshDirty.confirmLabel": "Refresh",
  "instanceShell.rightPanel.actions.refreshDirty.cancelLabel": "Cancel",
  "instanceShell.rightPanel.toast.saveSuccess": "File saved successfully",
  "instanceShell.rightPanel.toast.saveError": "Failed to save file",
  "instanceShell.rightPanel.sections.yoloMode": "Yolo Mode",
  "instanceShell.rightPanel.sections.yoloMode.tooltip": "Automatically approves permission requests for the current session. Use it only when you trust the tools being run.",
  "instanceShell.rightPanel.sections.tokens": "Tokens",
  "instanceShell.rightPanel.sections.tokens.tooltip": "Token usage and cost for this session and its subsessions.",
  "instanceShell.rightPanel.sections.backgroundProcesses": "Background Shells",
  "instanceShell.rightPanel.sections.backgroundProcesses.tooltip": "Native OpenCode background shells for the active workspace or worktree.",
  "instanceShell.backgroundProcesses.loading": "Loading background shells...",
  "instanceShell.backgroundProcesses.error": "Failed to load background shells.",
  "instanceShell.backgroundProcesses.empty": "No background shells.",
  "instanceShell.backgroundProcesses.status.running": "Running",
  "instanceShell.backgroundProcesses.status.exited": "Exited",
  "instanceShell.backgroundProcesses.status.timeout": "Timed out",
  "instanceShell.backgroundProcesses.status.killed": "Killed",
  "instanceShell.backgroundProcesses.pid": "PID {pid}",
  "instanceShell.backgroundProcesses.exitCode": "Exit {code}",
  "instanceShell.backgroundProcesses.actions.stopRemove": "Stop and remove",
  "instanceShell.backgroundProcesses.actions.remove": "Remove",
  "instanceShell.backgroundProcesses.actions.output": "View output",
  "instanceShell.backgroundProcesses.remove.title": "Remove background shell",
  "instanceShell.backgroundProcesses.remove.message": "Remove \"{title}\"? A running process will be stopped.",
  "instanceShell.rightPanel.sections.mcp": "MCP Servers",
  "instanceShell.rightPanel.sections.mcp.tooltip": "Model Context Protocol servers that extend the agent's capabilities with external tools and services.",
  "instanceShell.rightPanel.sections.lsp": "LSP Servers",
  "instanceShell.rightPanel.sections.lsp.tooltip": "Language Server Protocol servers providing code intelligence, diagnostics, and language-specific features.",
  "instanceShell.rightPanel.sections.plugins": "Plugins",
  "instanceShell.rightPanel.sections.plugins.tooltip": "Plugins that customize the UI and server behavior, adding features beyond MCP and LSP.",

  "instanceShell.gitChanges.noSessionSelected": "Select a session to view git changes.",
  "instanceShell.gitChanges.loading": "Loading git changes...",
  "instanceShell.gitChanges.empty": "No git changes yet.",
  "instanceShell.gitChanges.deleted": "Deleted",
  "instanceShell.gitChanges.hiddenRows.one": "1 file not shown",
  "instanceShell.gitChanges.hiddenRows.other": "{count} files not shown",
  "instanceShell.gitChanges.hiddenRows.show": "Show {count} more",
  "instanceShell.gitChanges.binaryViewer": "Binary file cannot be displayed",
  "instanceShell.gitChanges.sections.staged": "Staged Changes",
  "instanceShell.gitChanges.sections.unstaged": "Changes",
  "instanceShell.gitChanges.actions.insertContext": "Add to prompt",
  "instanceShell.gitChanges.actions.stage": "Stage file",
  "instanceShell.gitChanges.actions.stageSelected": "Stage {count} selected files",
  "instanceShell.gitChanges.actions.unstageSelected": "Unstage {count} selected files",
  "instanceShell.gitChanges.actions.unstage": "Unstage file",
  "instanceShell.gitChanges.commit.placeholder": "Enter commit message",
  "instanceShell.gitChanges.commit.submit": "Commit",
  "instanceShell.gitChanges.commit.submitting": "Committing...",
  "instanceShell.gitChanges.commit.success": "Commit created successfully",
  "instanceShell.gitChanges.commit.error": "Failed to create commit",

  "instanceShell.filesShell.fileListTitle": "File list",
  "instanceShell.filesShell.mobileSelectorLabel": "Select file",
  "instanceShell.filesShell.mobileSelectorEmpty": "Select a file",
  "instanceShell.filesShell.viewerTitle": "Change viewer",
  "instanceShell.filesShell.viewerPlaceholder": "Detailed change rendering will be added in the next step.",
  "instanceShell.filesShell.viewerEmpty": "No file selected.",
  "instanceShell.filesShell.listEmpty": "No files in this folder.",
  "instanceShell.filesShell.hideFiles": "Hide files",
  "instanceShell.filesShell.resizeFiles": "Resize file list",
  "instanceShell.filesShell.showFiles": "Show files",
  "instanceShell.filesShell.search.placeholder": "Filter files in this folder",
  "instanceShell.filesShell.search.ariaLabel": "Filter files in this folder",
  "instanceShell.filesShell.search.empty": "No matching files.",
  "instanceShell.filesShell.actions.copyPath": "Copy path",
  "instanceShell.filesShell.actions.more": "More actions for {name}",
  "instanceShell.filesShell.actions.openDefault": "Open with default application",
  "instanceShell.filesShell.actions.editDefault": "Edit with default application",
  "instanceShell.filesShell.actions.chooseApplication": "Open with...",
  "instanceShell.filesShell.actions.showInFolder": "Show in folder",
  "instanceShell.filesShell.actions.openFolder": "Open in file manager",
  "instanceShell.filesShell.actions.openTerminal": "Open terminal here",
  "instanceShell.filesShell.actions.openEditor": "Open in {editor}",
  "instanceShell.filesShell.toast.openError": "Could not open: {message}",
  "instanceShell.filesShell.toast.copyPathSuccess": "Copied path",
  "instanceShell.filesShell.toast.copyPathError": "Failed to copy path",
  "instanceShell.filesShell.previewMarkdown": "Preview Markdown",
  "instanceShell.filesShell.showSource": "Show source",
  "instanceShell.filesShell.enableWordWrap": "Enable word wrap",
  "instanceShell.filesShell.disableWordWrap": "Disable word wrap",
  "instanceShell.diff.hideUnchanged": "Hide unchanged regions",
  "instanceShell.diff.showFull": "Show full file",
  "instanceShell.diff.switchToSplit": "Switch to split view",
  "instanceShell.diff.switchToUnified": "Switch to unified view",
  "instanceShell.diff.enableWordWrap": "Enable word wrap",
  "instanceShell.diff.disableWordWrap": "Disable word wrap",
  "instanceShell.diff.whitespaceOnly": "Only whitespace changed in this file (indentation or trailing spaces).",
  "instanceShell.diff.lineEndingsOnly": "Only line endings (or a byte-order mark) changed in this file; its text is identical.",
  "instanceShell.worktree.create": "+ Create worktree",
  "instanceShell.worktree.unavailable": "Unavailable",
  "instanceShell.worktree.create.fromCurrentBranch": "New from current branch",
  "instanceShell.worktree.create.action": "Create and use worktree",
  "instanceShell.worktree.create.description": "Creates a named Git branch from this session's checkout and moves the session family to the new worktree. Uncommitted changes stay in the original checkout.",
  "instanceShell.worktree.create.name": "Name",
  "instanceShell.worktree.create.placeholder": "worktree-name",
  "instanceShell.worktree.create.success": "Created worktree {slug}",
  "instanceShell.worktree.create.error": "Failed to create worktree",
  "instanceShell.worktree.openInFileManager.action": "Open in file manager",
  "instanceShell.worktree.openInFileManager.error": "Failed to open worktree in file manager",
  "instanceShell.worktree.delete.action": "Delete worktree",
  "instanceShell.worktree.delete.description": "Deletes this branch worktree and its local folder.",
  "instanceShell.worktree.delete.target": "Worktree \"{slug}\"",
  "instanceShell.worktree.delete.force": "Force delete (discard local changes)",
  "instanceShell.worktree.delete.success": "Deleted worktree {slug}",
  "instanceShell.worktree.delete.error.title": "Delete failed",
  "instanceShell.worktree.delete.error.fallback": "Failed to delete worktree",
  "instanceShell.worktree.delete.error.causeLabel": "Likely cause:",
  "instanceShell.worktree.delete.error.nextStepLabel": "Suggested next step:",
  "instanceShell.worktree.delete.error.summary.localChanges": "Git refused to delete this worktree because it has modified or untracked files.",
  "instanceShell.worktree.delete.error.summary.inUse": "CodeNomad could not delete this worktree because something is still using files in the directory.",
  "instanceShell.worktree.delete.error.summary.notFound": "CodeNomad could not delete this worktree because the directory or worktree record was not found.",
  "instanceShell.worktree.delete.error.summary.permissionDenied": "CodeNomad could not delete this worktree because access to the directory was denied.",
  "instanceShell.worktree.delete.error.summary.unknown": "CodeNomad could not delete this worktree.",
  "instanceShell.worktree.delete.error.cause.localChanges": "Local changes",
  "instanceShell.worktree.delete.error.cause.inUse": "Another process is using this worktree",
  "instanceShell.worktree.delete.error.cause.notFound": "The worktree directory or record is missing",
  "instanceShell.worktree.delete.error.cause.permissionDenied": "Insufficient filesystem permissions",
  "instanceShell.worktree.delete.error.cause.unknown": "The backend returned an unclassified delete error",
  "instanceShell.worktree.delete.error.nextStep.localChanges": "Enable Force delete if you want to discard local changes, or clean the worktree and try again.",
  "instanceShell.worktree.delete.error.nextStep.inUse": "Close terminals, editors, watchers, or background processes using this worktree and try again.",
  "instanceShell.worktree.delete.error.nextStep.notFound": "Refresh worktrees and try again. If it still fails, inspect the worktree path on disk.",
  "instanceShell.worktree.delete.error.nextStep.permissionDenied": "Check filesystem permissions and close applications that may be locking this directory, then try again.",
  "instanceShell.worktree.delete.error.nextStep.unknown": "Review the raw error below for details, then retry after addressing the reported problem.",
  "instanceShell.worktree.delete.error.copyRaw": "Copy error",
  "instanceShell.worktree.delete.error.copySanitized": "Copy sanitized",
  "instanceShell.worktree.delete.error.copySuccess": "Copied delete error",
  "instanceShell.worktree.delete.error.copySanitizedSuccess": "Copied sanitized delete error",
  "instanceShell.worktree.delete.error.copyFailure": "Failed to copy delete error",


  "instanceShell.yoloMode.noSessionSelected": "Select a session to configure Yolo mode.",
  "instanceShell.yoloMode.title": "Yolo mode",
  "instanceShell.yoloMode.description": "Automatically approve permission requests for this session.",
  "instanceShell.yoloMode.badge": "Yolo",
  "instanceShell.yoloMode.badgeAriaLabel": "Yolo mode enabled",

  "versionPill.appWithVersion": "App {version}",
  "versionPill.ui": "UI",
  "versionPill.uiWithVersion": "UI {version}",
  "versionPill.source": " ({source})",

  "opencodeBinarySelector.title": "OpenCode Binary",
  "opencodeBinarySelector.subtitle": "Choose which executable OpenCode should run",
  "opencodeBinarySelector.customPath.placeholder": "Enter path to {name} binary…",
  "opencodeBinarySelector.actions.add": "Add",
  "opencodeBinarySelector.actions.browse": "Browse for Binary…",
  "opencodeBinarySelector.actions.removeTitle": "Remove binary",
  "opencodeBinarySelector.badge.systemPath": "Prefer PATH unless it holds an older OpenCode, then the user npm OpenCode 2",
  "opencodeBinarySelector.status.checkingVersions": "Checking versions…",
  "opencodeBinarySelector.status.checking": "Checking…",
  "opencodeBinarySelector.dialog.title": "Select OpenCode Binary",
  "opencodeBinarySelector.dialog.description": "Browse files exposed by the CLI server.",
  "opencodeBinarySelector.validation.invalidBinary": "Invalid OpenCode binary",
  "opencodeBinarySelector.validation.v2Required": "CodeNomad requires OpenCode V2. Install and select the opencode2 binary.",
  "opencodeBinarySelector.validation.alreadyValidating": "Already validating",
  "opencodeBinarySelector.display.systemPath": "{name} (automatic)",
  "opencodeBinarySelector.versionLabel": "v{version}",
} as const
